var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"sayfahead"},[_c('h1',[_vm._v(_vm._s(_vm.SayfaAdi))])]),_vm._v(" "),_c('div',{staticClass:"icerik"},[_c('el-row',{attrs:{"gutter":24}},[_c('el-col',{attrs:{"span":4}},[_c('IcraListe',{on:{"Kisi_id":function($event){return _vm.KisiGetir($event)}}})],1),_vm._v(" "),_c('el-col',{attrs:{"span":20}})],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2c942d46","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Icra/dosya/liste.vue
// module id = 1079
// module chunks = 0